module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_02-777844f0f429a8bee4969dc838995130.jpg";